import { gql } from "@apollo/client";

export const CREATE_SCHOOL_CLASS_MUTATION = gql`
  mutation CreateSchoolClass(
    $name: String!
    $academicYear: ID!
    $yearGroup: ID!
    $subject: ID!
    $school: ID!
  ) {
    createSchoolClass(
      name: $name
      academicYear: $academicYear
      yearGroup: $yearGroup
      subject: $subject
      school: $school
    ) {
      success
      message
      schoolClass {
        id
        name
      }
    }
  }
`;

export const CREATE_STUDENT_MUTATION = gql`
  mutation CreateStudent(
    $studentIdentifier: String!
    $firstName: String!
    $lastName: String!
    $yearGroup: ID
    $school: ID
    $schoolClass: ID
    $email: String
  ) {
    createStudent(
      studentIdentifier: $studentIdentifier
      firstName: $firstName
      lastName: $lastName
      yearGroup: $yearGroup
      school: $school
      schoolClass: $schoolClass
      email: $email
    ) {
      success
      message
      student {
        id
        identifier
        pseudonymisedAt
      }
    }
  }
`;
export const UPDATE_STUDENT_MUTATION = gql`
  mutation UpdateStudent(
    $student: ID!
    $studentIdentifier: String!
    $firstName: String!
    $lastName: String!
    $yearGroup: ID!
    $email: String
  ) {
    updateStudent(
      student: $student
      studentIdentifier: $studentIdentifier
      firstName: $firstName
      lastName: $lastName
      yearGroup: $yearGroup
      email: $email
    ) {
      success
      message
    }
  }
`;

export const CREATE_TEACHER_MUTATION = gql`
  mutation CreateTeacher(
    $firstName: String!
    $lastName: String!
    $school: ID!
    $email: String!
  ) {
    createTeacher(
      firstName: $firstName
      lastName: $lastName
      email: $email
      school: $school
    ) {
      success
      message
      teacher {
        id
      }
    }
  }
`;

export const ASSIGN_STUDENTS_MUTATION = gql`
  mutation AssignStudents($students: [ID]!, $schoolClass: ID!) {
    assignStudents(students: $students, schoolClass: $schoolClass) {
      success
      message
    }
  }
`;
export const REMOVE_STUDENTS_MUTATION = gql`
  mutation RemoveStudents($students: [ID]!, $schoolClass: ID!) {
    removeStudents(students: $students, schoolClass: $schoolClass) {
      success
      message
    }
  }
`;
export const ASSIGN_TEACHERS_MUTATION = gql`
  mutation AssignTeachers($teachers: [ID]!, $schoolClass: ID!) {
    assignTeachers(teachers: $teachers, schoolClass: $schoolClass) {
      success
      message
    }
  }
`;

export const REMOVE_TEACHERS_MUTATION = gql`
  mutation RemoveTeachers($teachers: [ID]!, $schoolClass: ID!) {
    removeTeachers(teachers: $teachers, schoolClass: $schoolClass) {
      success
      message
    }
  }
`;
export const EXTRACT_STUDENTS_FROM_FILE = gql`
  mutation ExtractStudents($file: Upload!, $schoolClass: ID!) {
    extractStudents(file: $file, schoolClass: $schoolClass) {
      success
      message
      suggestedStudents {
        Students {
          StudentIdentifier
          FirstName
          LastName
          IsNew
          Email
          DetailsDiffer
        }
      }
    }
  }
`;

export const BULK_UPLOAD_STUDENTS_MUTATION = gql`
  mutation BulkUploadStudents(
    $suggestedStudentListJson: String!
    $schoolClass: ID!
  ) {
    bulkUploadStudents(
      suggestedStudentListJson: $suggestedStudentListJson
      schoolClass: $schoolClass
    ) {
      success
      message
    }
  }
`;

export const CONFIGURE_SCHOOL_SUBSCRIPTION = gql`
  mutation (
    $school: ID!
    $subscriptionType: String!
    $domains: [String]!
    $isApproved: Boolean!
    $acknowledgeArchive: Boolean
  ) {
    configureSchoolSubscription(
      school: $school
      subscriptionType: $subscriptionType
      domains: $domains
      isApproved: $isApproved
      acknowledgeArchive: $acknowledgeArchive
    ) {
      success
      message
    }
  }
`;
export const OFFBOARD_SCHOOL_MUTATION = gql`
  mutation ($school: ID!) {
    offboardSchool(school: $school) {
      success
      message
    }
  }
`;

export const UPDATE_SCHOOL_SUBSCRIPTION_LICENSES = gql`
  mutation UpdateSchoolSubscriptionLicenses(
    $school: ID!
    $licenseItems: [YearGroupLicenceUpdateItem!]!
  ) {
    updateSchoolSubscriptionLicenses(
      school: $school
      licenseItems: $licenseItems
    ) {
      success
      message
    }
  }
`;

export const UPDATE_SCHOOL_CLASS_MUTATION = gql`
  mutation UpdateSchoolClass(
    $schoolClasses: [ID]!
    $subject: ID!
    $yearGroup: ID!
    $wondeId: String
    $singleClass: Boolean
  ) {
    updateSchoolClass(
      schoolClasses: $schoolClasses
      subject: $subject
      yearGroup: $yearGroup
      wondeId: $wondeId
      singleClass: $singleClass
    ) {
      success
      message
      schoolClasses {
        id
        name
        isActive
        wondeId
        wondeNeedsReview
        wondeLastSynced
        yearGroup {
          id
          yearGroup
        }
        subject {
          id
          name
        }
      }
    }
  }
`;

export const MERGE_SCHOOL_CLASS_MUTATION = gql`
  mutation mergeSchoolClass($schoolClass: ID!, $mergeClass: ID!) {
    mergeSchoolClass(schoolClass: $schoolClass, mergeClass: $mergeClass) {
      success
      message
      schoolClass {
        id
        name
        isActive
        wondeId
        wondeNeedsReview
        wondeLastSynced
        yearGroup {
          id
          yearGroup
        }
        subject {
          id
          name
        }
      }
    }
  }
`;

export const MANAGE_ACCOUNT_SCHOOL_SUBSCRIPTION = gql`
  mutation ManageAccountSchoolSubscription(
    $licenseItems: [AccountSchoolLicenceInput!]!
    $revision: String!
  ) {
    manageAccountSchoolSubscription(
      licenseItems: $licenseItems
      revision: $revision
    ) {
      success
      message
    }
  }
`;
